import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-gray-900 text-white py-16 px-4 border-y border-gray-800" data-id="element-114">
      <div className="max-w-4xl mx-auto" data-id="element-115">
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 border border-gray-700 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-116">
          {/* Decorative background element */}
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-117"></div>

          <div className="flex flex-col md:flex-row items-center gap-8 relative z-10" data-id="element-118">
            <div className="shrink-0" data-id="element-119">
              <ShieldCheckIcon className="w-24 h-24 text-amber-500" data-id="element-120" />
            </div>

            <div className="text-center md:text-left" data-id="element-121">
              <div className="inline-block bg-emerald-500/10 text-emerald-400 font-bold px-3 py-1 rounded-full text-sm mb-4 border border-emerald-500/20" data-id="element-122">
                $0.00 RISK FOR YOU
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-123">
                The "Keep It Anyway" Guarantee
              </h2>
              <p className="text-gray-300 text-lg leading-relaxed mb-4" data-id="element-124">
                If you don't feel 100% more vital, focused, and "driven" in the
                next 30 days, just email us for a full refund of your $6.36. No
                questions asked.
              </p>
              <p className="text-amber-400 font-semibold text-lg" data-id="element-125">
                And you can KEEP the Ebook and all the Bonuses anyway.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}